import React from "react";
import { X } from "lucide-react";

const ProgressBar = ({
    fileName,
    fileType,
    progress,
    currentSize,
    totalSize,
    onCancel,
}) => {
    const fileExt = fileType || fileName.split(".").pop() || "file";

    return (
        <div className="flex items-center gap-4 w-full p-3 bg-white">
            {/* File Placeholder */}
            <div className="w-12 h-12 flex items-center justify-center bg-gray-200 rounded-tl-md rounded-tr-xl rounded-bl-md rounded-br-md">
                <span className="text-sm font-bold text-gray-700 uppercase">.{fileExt}</span>
            </div>

            {/* File Info */}
            <div className="flex-1">
                <p className="text-gray-800 text-left font-medium text-sm truncate">
                    {fileName}
                </p>
                <div className="w-full h-2 bg-gray-200 rounded-full mt-2 relative">
                    <div
                        className="h-2 bg-blue-500 rounded-full transition-all"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                <div className="flex justify-between">
                    <p className="text-xs text-left text-gray-500 mt-1">
                        {currentSize} of {totalSize}
                    </p>
                    <p className="text-sm text-gray-600 text-right">{progress}%</p>
                </div>
            </div>

            {/* Cancel Button */}
            <div className="flex items-center gap-3">
                <button
                    onClick={onCancel}
                    className="text-gray-500 hover:text-red-500 transition"
                >
                    <X size={18} />
                </button>
            </div>
        </div>
    );
};

export default ProgressBar;
